import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lidoKeyConfig = {
  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lido Key Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Lido Key, FL. Sam\'s Tree Service handles dangerous and hazardous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lido_key',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lido Key',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lido Key Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand the unique challenges that coastal living 
     brings to tree care in <strong>Lido Key</strong>. Salt air, high winds, and tropical storms put 
     enormous stress on trees, making overgrown or weakened limbs a serious threat to your home 
     and property. Whether branches are pushing against your roofline, crowding your seawall, 
     or growing dangerously close to power lines, our team delivers precise trimming and safe 
     removal to protect what matters most.`,

    `We specialize in <strong>dangerous and hazardous tree situations</strong> storm battered limbs, 
     salt damaged trunks, leaning palms, and dense canopy overgrowth that puts coastal properties 
     at risk. Every job is customized to the specific needs of your landscape and the demands of 
     Florida's hurricane season.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable, and expert tree care 
     throughout <strong>Lido Key</strong> and the surrounding <strong>Sarasota barrier island</strong> communities, 
     keeping your property safe and your trees healthy all year long.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lido Key, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_LidoKey = () => <LocationPage config={lidoKeyConfig} />;
export default Services_LidoKey;
